/**
 * Menu Items Table Component
 * Table layout with header and rows for list view
 */

import React from 'react';
import { MenuItem } from '../../../../types/menu';
import { MenuItemRow } from './MenuItemRow';

interface MenuItemsTableProps {
  canManageMenu?: boolean;
  items: MenuItem[];
  selectedOutletName?: string | null;
  onEdit: (item: MenuItem) => void;
  onDelete: (item: MenuItem) => void;
  formatPrice: (price: number) => string;
}

const TableHeader: React.FC = () => (
  <div className="grid grid-cols-12 gap-4 px-6 py-3 bg-gray-50 border-b border-gray-200 text-sm font-medium text-gray-500">
    <div className="col-span-3">Item</div>
    <div className="col-span-2">Outlet</div>
    <div className="col-span-2">Category</div>
    <div className="col-span-2">Department</div>
    <div className="col-span-1">Price</div>
    <div className="col-span-1">Status</div>
    <div className="col-span-1 text-right">Actions</div>
  </div>
);

export const MenuItemsTable: React.FC<MenuItemsTableProps> = ({
  canManageMenu = true,
  items,
  selectedOutletName,
  onEdit,
  onDelete,
  formatPrice,
}) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden ">
      <TableHeader />
      <div className="divide-y divide-gray-100">
        {items.map((item) => (
          <MenuItemRow
            key={item.id}
            canManageMenu={canManageMenu}
            item={item}
            selectedOutletName={selectedOutletName}
            onEdit={onEdit}
            onDelete={onDelete}
            formatPrice={formatPrice}
          />
        ))}
      </div>
    </div>
  );
};
